module.exports = __webpack_public_path__ + "img/Nevada Department of Business and Industry Logo.c2feea83.jpg";